/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pTab.vue?vue&type=template&id=5194f273&scoped=true"
import script from "./pTab.vue?vue&type=script&lang=js"
export * from "./pTab.vue?vue&type=script&lang=js"
import style0 from "./pTab.vue?vue&type=style&index=0&id=5194f273&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5194f273",
  null
  
)

export default component.exports